import { useEffect } from 'react';
import { setSSRHead } from '../lib/ssrHead';

const ORIGIN = 'https://lotto-number-generator.com';

// Canonical URL: trailing slash for all paths so it matches Cloudflare Pages' served URLs.
function buildCanonical(path: string): string {
  if (path === '/' || path.endsWith('/')) return `${ORIGIN}${path}`;
  return `${ORIGIN}${path}/`;
}

export function usePageMeta(opts: { title: string; description: string; path: string; noindex?: boolean }) {
  // During SSR (renderToString), effects don't run — capture head data in the function body.
  if (typeof window === 'undefined') {
    setSSRHead({ title: opts.title, description: opts.description, path: opts.path, noindex: opts.noindex ?? false });
  }

  useEffect(() => {
    document.title = opts.title;
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement('meta');
      desc.setAttribute('name', 'description');
      document.head.appendChild(desc);
    }
    desc.setAttribute('content', opts.description);

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = buildCanonical(opts.path);

    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', opts.noindex ? 'noindex, follow' : 'index, follow');
  }, [opts.title, opts.description, opts.path, opts.noindex]);
}
